module.exports = __webpack_public_path__ + "img/reload_stamps.5af6885f.png";